export * from './delete-zeit-unterart.component';
export * from './delete-zeit-unterart.component.module';